import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=11023b0b&"
import script from "./CustomerItem.vue?vue&type=script&lang=js&"
export * from "./CustomerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports